// removed by extract-text-webpack-plugin
module.exports = {"root":"_30xc6","details":"_1ymfj","selected":"EjM61","figure":"yaqUk","avatar":"_1tK1v","title":"_1he8t","description":"_3PvvU","tag":"_1FUWx"};


//////////////////
// WEBPACK FOOTER
// ../source/components/SearchResult/styles.css
// module id = 1615
// module chunks = 6